import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('korefolio_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('korefolio_admin_token');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

// Access validation
export const validateAccessCode = async (code) => {
  const response = await api.post('/pitch/validate-code', { code });
  return response.data;
};

// Pitch content
export const getPitchContent = async () => {
  const response = await api.get('/pitch/content');
  return response.data;
};

// Analytics tracking
export const trackEvent = async (eventType, data, sessionId, accessCode) => {
  try {
    await api.post('/analytics/track', {
      eventType,
      sessionId,
      accessCode,
      data
    });
  } catch (e) {
    // Silent fail for analytics
    console.debug('Analytics track failed:', e);
  }
};

// AI Q&A
export const askQuestion = async (question, sessionId, accessCode) => {
  const response = await api.post('/ai/ask', { question, sessionId, accessCode });
  return response.data;
};

export const getSuggestions = async () => {
  const response = await api.get('/ai/suggestions');
  return response.data;
};

// Email signup
export const submitEmailSignup = async (data) => {
  const response = await api.post('/email/signup', data);
  return response.data;
};

// Admin auth
export const adminLogin = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const getAdminUser = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

// Admin dashboard
export const getDashboardStats = async () => {
  const response = await api.get('/admin/dashboard');
  return response.data;
};

export const getAccessCodes = async () => {
  const response = await api.get('/admin/access-codes');
  return response.data;
};

export const createAccessCode = async (data) => {
  const response = await api.post('/admin/access-codes', data);
  return response.data;
};

export const updateAccessCode = async (id, data) => {
  const response = await api.put(`/admin/access-codes/${id}`, data);
  return response.data;
};

export const deleteAccessCode = async (id) => {
  const response = await api.delete(`/admin/access-codes/${id}`);
  return response.data;
};

export const getSignups = async (params) => {
  const response = await api.get('/admin/signups', { params });
  return response.data;
};

export const getAnalyticsStats = async (params) => {
  const response = await api.get('/analytics/stats', { params });
  return response.data;
};

export default api;
